
import { PropType, defineComponent } from 'vue';
import { NNotification } from 'SharedDir/declarations/notification.d';

import NotificationCard from './NotificationCard.vue';

export default defineComponent({
  name: 'NotificationList',
  components: {
    NotificationCard,
  },
  props: {
    notifications: {
      type: Array as PropType<NNotification.NotificationList>,
      required: true,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
});
